export default (form, languages) => {
	const body = {};

	languages.forEach((lang) => {
		body[lang.uuid] = {
			imageUuid: form.featuredImage.uuid,
			cardImageUuid: form.cardImage.uuid,
			name: form[`${lang.uuid}-name`],
			slug: form[`${lang.uuid}-slug`],
			rteText: form[`${lang.uuid}-rteText`],
			products: [],
			seoTitle: form[`${lang.uuid}-seoTitle`],
			seoDescription: form[`${lang.uuid}-seoDescription`],
		};
	});

	return body;
};



// WEBPACK FOOTER //
// ./src/helpers/formatProjectAddBody.js